import { Injectable } from '@angular/core';
import { AlertButton } from '@shared/alert/alertButton';
import { AlertHelper } from '@shared/alert/alert.helper';
import { UserActionsLoggingManager } from '@user/service/logging/user-actions-logging.manager';
import { ProjectModel } from '../model/project.model';
import { ProjectService } from '../components/import-export/service/project.service';
import { FileService } from '@shared/file/file.service';
import { ProjectExportDataService } from '../components/import-export/service/project-export-data.service';
import { CaeService } from '../cae/cae.service';
import { ProjectComponentPresenter } from '../components/project-component.presenter';

@Injectable({ providedIn: 'root' })
export class CsvImportService {

  constructor(
    private alertHelper: AlertHelper,
    private userActionsLoggingManager: UserActionsLoggingManager,
    private projectModel: ProjectModel,
    private projectService: ProjectService,
    private fileService: FileService,
    private projectExportDataService: ProjectExportDataService,
    private caeService: CaeService,
    private projectComponentPresenter: ProjectComponentPresenter,
  ) {
  }

  public async startCsvImport(): Promise<void> {

    const answer = await this.alertHelper.showAlert('header.menu.csv', 'excelImport.message', {}, [ AlertButton.OK, AlertButton.CANCEL ]);
    if (answer !== AlertButton.OK) {
      return;
    }

    this.userActionsLoggingManager.logFunction('Csv_Import');

    this.projectModel.projectChangeHandler();
    if (!await this.projectService.checkConfirmCloseProject('main.import.title.confirm_import_project', 'main.import.message.confirm_import_project')) {
      return;
    }

    const file = await this.fileService.loadFileWithErrorHandling('.csv');
    if (!file) {
      return;
    }

    const caeDataObservable = this.projectExportDataService.importProjectFromCsv(await file.text());
    const csvData = await this.caeService.validateProjectWithErrorHandling(caeDataObservable);

    if (!csvData) {
      return;
    }

    this.projectComponentPresenter.openCsvImportOptions(csvData);
  }
}
